


<div class="container">
         <div class="row">

<div *ngIf="!dictionaryLoaded && !formSubmitted" class="d-flex justify-content-center my-5">
  Loading...
</div>

<app-thank-you *ngIf="formSubmitted"></app-thank-you>

<form *ngIf="!formSubmitted && dictionaryLoaded" [formGroup]="parentFormGroup" (ngSubmit)="onSubmit()">

  <!-- Inquiry Type Dropdown -->
  <div class="row mb-4" *ngIf="!isMxLang">
    <div class="col-md-12">
      <div class="form-group">

        <span>{{ labels.headDesc }}</span>

        <br>

        <h4>{{ labels.inquiryType }}</h4>
        <select
          id="inquiryType"
          class="form-control"
          formControlName="inquiryType">
          <option value="" disabled selected>{{placeholders.selectOption}}</option>
          <option *ngFor="let type of inquiryTypes" [value]="type.key">
            {{ type.label }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <app-get-quote *ngIf="parentFormGroup.get('inquiryType')?.value === 'getAQuote'" (formReady)="addChildForm('getquote', $event)"></app-get-quote>
  
  <app-report-claim *ngIf="parentFormGroup.get('inquiryType')?.value === 'reportAClaim'" ></app-report-claim>

  <app-req-loss-run *ngIf="parentFormGroup.get('inquiryType')?.value === 'requestLossRun'"></app-req-loss-run>

  <app-get-help-login *ngIf="parentFormGroup.get('inquiryType')?.value === 'getHelpLoggingIn'" (formReady)="addChildForm('loginhelp', $event)"></app-get-help-login>

  <app-req-policy-doc *ngIf="parentFormGroup.get('inquiryType')?.value === 'requestPolicyDoc'" (formReady)="addChildForm('policydoc', $event)"></app-req-policy-doc>

  <app-req-commission *ngIf="parentFormGroup.get('inquiryType')?.value === 'requestCommission'" (formReady)="addChildForm('commission', $event)"></app-req-commission>

  <app-ques-bill-payment *ngIf="parentFormGroup.get('inquiryType')?.value === 'questionBillPayment'" (formReady)="addChildForm('billpayment', $event)"></app-ques-bill-payment>

  <app-become-appointed *ngIf="parentFormGroup.get('inquiryType')?.value === 'becomeAppointed'" (formReady)="addChildForm('appointed', $event)"></app-become-appointed>

  <app-careers *ngIf="parentFormGroup.get('inquiryType')?.value === 'careers'" (formReady)="addChildForm('career', $event)"></app-careers>

  <app-ask-product *ngIf="parentFormGroup.get('inquiryType')?.value === 'askAboutProduct'" (formReady)="addChildForm('askproduct', $event)"></app-ask-product>

  <app-emp-veri *ngIf="parentFormGroup.get('inquiryType')?.value === 'employmentVerification'"></app-emp-veri>

  <app-complaints *ngIf="parentFormGroup.get('inquiryType')?.value === 'complaints'"></app-complaints>

  <app-other *ngIf="parentFormGroup.get('inquiryType')?.value === 'other'" (formReady)="addChildForm('other', $event)"></app-other>
 
  <app-contact-details *ngIf="CONTACT_DETAILS_KEYS.includes(parentFormGroup.get('inquiryType')?.value) && !isMxLang" [parentForm]="parentFormGroup" [showValidationError]="showValidationError" [showSubmissionError]="showSubmissionError" (formReady)="addChildForm('contactinfo', $event)"></app-contact-details>

  <app-contact-mx *ngIf="isMxLang" [parentForm]="parentFormGroup" [showValidationError]="showValidationError" [showSubmissionError]="showSubmissionError" (formReady)="addChildForm('contactinfo', $event)"></app-contact-mx>



</form>
</div>

  </div>

